import React from 'react';
import styles from './FieldDescription.module.scss';

export const FieldDescription: React.FC<{ description: string }> = ({ description }) => {
    if (!description) {
        return null;
    }

    return <div className={styles.fieldDescription}>{description}</div>;
};
